
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournaments/quick",
      function () {
        return require("private-next-pages/tournaments/quick/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tournaments/quick"])
      });
    }
  